import React from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'
import Helmet from 'react-helmet'

import Login from './index'

class App extends React.Component {
  render () {
    return (
      <div className='App'>
        <div className='Layout'>
          <div className='LayoutMain'>
            <Switch>
              <Route path='/workspace'>
                <Helmet>
                  <title>Select Workspace – WebMango</title>
                </Helmet>
              </Route>
              <Route>
                <Helmet>
                  <title>Login – WebMango</title>
                </Helmet>
              </Route>
            </Switch>
            <Login />
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(App)



// WEBPACK FOOTER //
// ./src/components/Login/App.js